// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbWrapper":"Breadcrumb_breadcrumbWrapper__14GP5","breadcrumbItem":"Breadcrumb_breadcrumbItem__EoFMs","breadcrumbLink":"Breadcrumb_breadcrumbLink__Ftv_N"};